import React from 'react';
import { connect } from 'react-redux';
import { localize } from 'core/localization';
import { ICON } from 'constants/components';
import {
  isAttemptsLimited,
  getLimitedAttemptsNumber,
  shouldSubmitAllQuestions
} from 'store/settings/selectors';
import { RootAppState } from 'store/types';
import { getCourseAttempt } from 'store/course/selectors';
import {
  RemainingAttemptsBlockText,
  RemainingAttemptsWrapper,
  InfoIcon
} from './RemainingAttemptsBlock.styled';

type RemainingAttemptsBlockProps = {
  isSubmitAtOnce: boolean;
  isLimitedAttempts: boolean;
  allowedAttempts: number;
  usedAttempts: number;
  isResultsPage: boolean;
  text?: string;
  isQuestionPage?: boolean;
  remainingQuestionAttempt?: number;
  setShowRemainingAttemptsBlock?(value: boolean): void;
};

export class RemainingAttemptsBlock extends React.Component<RemainingAttemptsBlockProps> {
  render() {
    const {
      isSubmitAtOnce,
      isLimitedAttempts,
      allowedAttempts,
      usedAttempts,
      isResultsPage,
      text,
      isQuestionPage = false,
      remainingQuestionAttempt = 0,
      setShowRemainingAttemptsBlock
    } = this.props;

    const remainingAttempts = allowedAttempts - usedAttempts;
    let remainingAttemptsText = `${localize('[remaining attempts]')} ${remainingAttempts}`;

    if (remainingAttempts === 1 && !isResultsPage && allowedAttempts > 1) {
      remainingAttemptsText = localize('[only this attempt left]');
    }

    if (allowedAttempts === 1) {
      remainingAttemptsText = localize('[one attempt to complete course]');
    }

    const shouldDisplay =
      isQuestionPage ||
      (isSubmitAtOnce &&
        isLimitedAttempts &&
        remainingAttempts > 0 &&
        (remainingAttempts < allowedAttempts || allowedAttempts === 1));

    if (!isQuestionPage && setShowRemainingAttemptsBlock) {
      setShowRemainingAttemptsBlock(shouldDisplay);
    }

    const hasOneRemainingAttempt = isQuestionPage
      ? remainingQuestionAttempt === 1
      : remainingAttempts === 1;
    return (
      shouldDisplay && (
        <RemainingAttemptsWrapper hasOneRemainingAttempt={hasOneRemainingAttempt}>
          <InfoIcon
            name="info"
            color="mainColor"
            shapeColor="textColor"
            size="small"
            shape={ICON.SHAPES.ROUND_OUTLINED}
            hasOneRemainingAttempt={hasOneRemainingAttempt}
          />
          <RemainingAttemptsBlockText>{text || remainingAttemptsText}</RemainingAttemptsBlockText>
        </RemainingAttemptsWrapper>
      )
    );
  }
}

const mapStateToProps = (state: RootAppState) => ({
  isSubmitAtOnce: shouldSubmitAllQuestions(state),
  isLimitedAttempts: isAttemptsLimited(state),
  allowedAttempts: getLimitedAttemptsNumber(state),
  usedAttempts: getCourseAttempt(state)
});
export default connect(mapStateToProps)(RemainingAttemptsBlock);
